import translations from './translations'

translations.add('pt', {
    tryAgain: 'Tente novamente',
    failure: 'Falha'
})
